/* tslint:disable */
/* eslint-disable */
/**
 * MCC Service API
 * Provides endpoints for MCC Dashboard
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: schmiedev@schmiede.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActuationPerformanceItemDto
 */
export interface ActuationPerformanceItemDto {
    /**
     * 
     * @type {number}
     * @memberof ActuationPerformanceItemDto
     */
    'successPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof ActuationPerformanceItemDto
     */
    'totalTargets': number;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunMetricTotalsResponseDto
 */
export interface AggregateModuleRunMetricTotalsResponseDto {
    /**
     * 
     * @type {AggregateModuleRunMetricTotalsResponseDtoAllTime}
     * @memberof AggregateModuleRunMetricTotalsResponseDto
     */
    'allTime': AggregateModuleRunMetricTotalsResponseDtoAllTime;
    /**
     * 
     * @type {AggregateModuleRunMetricTotalsResponseDtoAllTime}
     * @memberof AggregateModuleRunMetricTotalsResponseDto
     */
    'thisWeek': AggregateModuleRunMetricTotalsResponseDtoAllTime;
    /**
     * 
     * @type {AggregateModuleRunMetricTotalsResponseDtoAllTime}
     * @memberof AggregateModuleRunMetricTotalsResponseDto
     */
    'thisMonth': AggregateModuleRunMetricTotalsResponseDtoAllTime;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunMetricTotalsResponseDtoAllTime
 */
export interface AggregateModuleRunMetricTotalsResponseDtoAllTime {
    /**
     * 
     * @type {number}
     * @memberof AggregateModuleRunMetricTotalsResponseDtoAllTime
     */
    'massKg'?: number;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsRequestDto
 */
export interface AggregateModuleRunsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AggregateModuleRunsRequestDto
     */
    'runIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsRequestDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsRequestDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsRequestDto
     */
    'endTime'?: string;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsResponseDto
 */
export interface AggregateModuleRunsResponseDto {
    /**
     * 
     * @type {{ [key: string]: ActuationPerformanceItemDto; }}
     * @memberof AggregateModuleRunsResponseDto
     */
    'actuationPerformance': { [key: string]: ActuationPerformanceItemDto; };
    /**
     * 
     * @type {Array<string>}
     * @memberof AggregateModuleRunsResponseDto
     */
    'programs': Array<string>;
    /**
     * 
     * @type {AggregateModuleRunsResponseDtoStartTime}
     * @memberof AggregateModuleRunsResponseDto
     */
    'startTime': AggregateModuleRunsResponseDtoStartTime;
    /**
     * 
     * @type {AggregateModuleRunsResponseDtoStartTime}
     * @memberof AggregateModuleRunsResponseDto
     */
    'endTime': AggregateModuleRunsResponseDtoStartTime;
    /**
     * 
     * @type {AggregateModuleRunsResponseDtoRunTime}
     * @memberof AggregateModuleRunsResponseDto
     */
    'runTime': AggregateModuleRunsResponseDtoRunTime;
    /**
     * 
     * @type {AggregateModuleRunsResponseDtoTotals}
     * @memberof AggregateModuleRunsResponseDto
     */
    'totals': AggregateModuleRunsResponseDtoTotals;
    /**
     * 
     * @type {Array<string>}
     * @memberof AggregateModuleRunsResponseDto
     */
    'runIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDto
     */
    'moduleId': string;
    /**
     * 
     * @type {boolean}
     * @memberof AggregateModuleRunsResponseDto
     */
    'areAllTargetsSame': boolean;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsResponseDtoRunTime
 */
export interface AggregateModuleRunsResponseDtoRunTime {
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoRunTime
     */
    'days'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoRunTime
     */
    'hours'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoRunTime
     */
    'minutes'?: string;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsResponseDtoStartTime
 */
export interface AggregateModuleRunsResponseDtoStartTime {
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoStartTime
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoStartTime
     */
    'time'?: string;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsResponseDtoTotals
 */
export interface AggregateModuleRunsResponseDtoTotals {
    /**
     * 
     * @type {object}
     * @memberof AggregateModuleRunsResponseDtoTotals
     */
    'byLabel'?: object;
    /**
     * 
     * @type {object}
     * @memberof AggregateModuleRunsResponseDtoTotals
     */
    'byQuality'?: object;
    /**
     * 
     * @type {number}
     * @memberof AggregateModuleRunsResponseDtoTotals
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AggregateModuleRunsResponseDtoTotals
     */
    'mass'?: number;
}
/**
 * 
 * @export
 * @interface AllUsersResponseDto
 */
export interface AllUsersResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ArtifactThresholdDto
 */
export interface ArtifactThresholdDto {
    /**
     * 
     * @type {string}
     * @memberof ArtifactThresholdDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactThresholdDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ArtifactThresholdDto
     */
    'percentThreshold': number;
    /**
     * 
     * @type {boolean}
     * @memberof ArtifactThresholdDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface AugmentedModuleRunDto
 */
export interface AugmentedModuleRunDto {
    /**
     * 
     * @type {ModuleRunDto}
     * @memberof AugmentedModuleRunDto
     */
    'moduleRun': ModuleRunDto;
    /**
     * 
     * @type {ChartDataDto}
     * @memberof AugmentedModuleRunDto
     */
    'chartData': ChartDataDto;
}
/**
 * 
 * @export
 * @interface ChartDataDto
 */
export interface ChartDataDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'badProductsPerHour': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'goodProductsPerHour': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChartDataDto
     */
    'goodProductsPerHourTime': Array<string>;
}
/**
 * 
 * @export
 * @interface ClassDistributionDto
 */
export interface ClassDistributionDto {
    /**
     * 
     * @type {string}
     * @memberof ClassDistributionDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof ClassDistributionDto
     */
    'percent': number;
    /**
     * 
     * @type {number}
     * @memberof ClassDistributionDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClassDistributionDto
     */
    'totalWeight': number;
}
/**
 * 
 * @export
 * @interface CreateModuleDto
 */
export interface CreateModuleDto {
    /**
     * 
     * @type {CreteModuleNotificationSettingsDto}
     * @memberof CreateModuleDto
     */
    'notificationSettings'?: CreteModuleNotificationSettingsDto;
    /**
     * 
     * @type {string}
     * @memberof CreateModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateModuleDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateModuleDto
     */
    'imageKey'?: string;
}
/**
 * 
 * @export
 * @interface CreteModuleNotificationSettingsDto
 */
export interface CreteModuleNotificationSettingsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreteModuleNotificationSettingsDto
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreteModuleNotificationSettingsDto
     */
    'useDefaultNotificationSettings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreteModuleNotificationSettingsDto
     */
    'emailNotificationsEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CurrentUserModuleResponseDto
 */
export interface CurrentUserModuleResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentUserModuleResponseDto
     */
    'type'?: CurrentUserModuleResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserModuleResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserModuleResponseDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserModuleResponseDto
     */
    'shouldDisplayLiveData': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserModuleResponseDto
     */
    'featureFlags': Array<string>;
}

export const CurrentUserModuleResponseDtoTypeEnum = {
    Farmsort: 'FARMSORT',
    Camera: 'CAMERA',
    NotAssigned: 'NOT_ASSIGNED'
} as const;

export type CurrentUserModuleResponseDtoTypeEnum = typeof CurrentUserModuleResponseDtoTypeEnum[keyof typeof CurrentUserModuleResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface CurrentUserResponseDto
 */
export interface CurrentUserResponseDto {
    /**
     * 
     * @type {Array<CurrentUserModuleResponseDto>}
     * @memberof CurrentUserResponseDto
     */
    'modules': Array<CurrentUserModuleResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'role'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserResponseDto
     */
    'featureFlags': Array<string>;
}
/**
 * 
 * @export
 * @interface DefaultNotificationSettingsDto
 */
export interface DefaultNotificationSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof DefaultNotificationSettingsDto
     */
    'emailNotificationEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultNotificationSettingsDto
     */
    'smsNotificationEnabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultNotificationSettingsDto
     */
    'phoneNumbers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultNotificationSettingsDto
     */
    'emails': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DefaultNotificationSettingsDto
     */
    'dndStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof DefaultNotificationSettingsDto
     */
    'dndEnd': string | null;
}
/**
 * 
 * @export
 * @interface ErrorLogDto
 */
export interface ErrorLogDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorLogDto
     */
    'isTracked': boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'code': string;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorLogDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface GetPresignedUploadUrlResponseDto
 */
export interface GetPresignedUploadUrlResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetPresignedUploadUrlResponseDto
     */
    'imageKey': string;
    /**
     * 
     * @type {string}
     * @memberof GetPresignedUploadUrlResponseDto
     */
    'mimeType': string;
    /**
     * 
     * @type {string}
     * @memberof GetPresignedUploadUrlResponseDto
     */
    'uploadUrl': string;
}
/**
 * 
 * @export
 * @interface HealthControllerGetHealth200Response
 */
export interface HealthControllerGetHealth200Response {
    /**
     * 
     * @type {string}
     * @memberof HealthControllerGetHealth200Response
     */
    'status'?: string;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth200Response
     */
    'info'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth200Response
     */
    'error'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth200Response
     */
    'details'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; };
}
/**
 * 
 * @export
 * @interface HealthControllerGetHealth200ResponseInfoValue
 */
export interface HealthControllerGetHealth200ResponseInfoValue {
    [key: string]: string | any;

    /**
     * 
     * @type {string}
     * @memberof HealthControllerGetHealth200ResponseInfoValue
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface HealthControllerGetHealth503Response
 */
export interface HealthControllerGetHealth503Response {
    /**
     * 
     * @type {string}
     * @memberof HealthControllerGetHealth503Response
     */
    'status'?: string;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth503Response
     */
    'info'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth503Response
     */
    'error'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth503Response
     */
    'details'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; };
}
/**
 * 
 * @export
 * @interface IntervallNotificationSettingsRequestDto
 */
export interface IntervallNotificationSettingsRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IntervallNotificationSettingsRequestDto
     */
    'intervalInMinutes': number;
}
/**
 * 
 * @export
 * @interface ListModuleNotificationSettingsResponseDto
 */
export interface ListModuleNotificationSettingsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<ModuleNotificationSettingsDto>}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'results': Array<ModuleNotificationSettingsDto>;
}
/**
 * 
 * @export
 * @interface ListModuleRunsRequestDto
 */
export interface ListModuleRunsRequestDto {
    /**
     * current page
     * @type {number}
     * @memberof ListModuleRunsRequestDto
     */
    'page'?: number;
    /**
     * rows per page
     * @type {number}
     * @memberof ListModuleRunsRequestDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListModuleRunsRequestDto
     */
    'program'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListModuleRunsRequestDto
     */
    'runIntervalStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListModuleRunsRequestDto
     */
    'runIntervalEnd'?: string;
    /**
     * 
     * @type {ListModuleRunsSortCriteriaDto}
     * @memberof ListModuleRunsRequestDto
     */
    'sortBy'?: ListModuleRunsSortCriteriaDto;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsRequestDto
     */
    'filterSmallRuns'?: boolean;
}
/**
 * 
 * @export
 * @interface ListModuleRunsResponseDto
 */
export interface ListModuleRunsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListModuleRunsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleRunsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleRunsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleRunsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<ModuleRunsDto>}
     * @memberof ListModuleRunsResponseDto
     */
    'results': Array<ModuleRunsDto>;
}
/**
 * 
 * @export
 * @interface ListModuleRunsSortCriteriaDto
 */
export interface ListModuleRunsSortCriteriaDto {
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'program'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'startTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'duration'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'totalCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'totalMass'?: boolean;
}
/**
 * 
 * @export
 * @interface ListModulesResponseDto
 */
export interface ListModulesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListModulesResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListModulesResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListModulesResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListModulesResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<ModuleDto>}
     * @memberof ListModulesResponseDto
     */
    'results': Array<ModuleDto>;
}
/**
 * 
 * @export
 * @interface ListNotificationRequestFiltersDto
 */
export interface ListNotificationRequestFiltersDto {
    /**
     * required if \"dateTo\" passed
     * @type {string}
     * @memberof ListNotificationRequestFiltersDto
     */
    'dateFrom'?: string;
    /**
     * required if \"dateFrom\" passed
     * @type {string}
     * @memberof ListNotificationRequestFiltersDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListNotificationRequestFiltersDto
     */
    'isRead'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListNotificationRequestFiltersDto
     */
    'moduleId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ListNotificationRequestScope = {
    Module: 'MODULE',
    User: 'USER'
} as const;

export type ListNotificationRequestScope = typeof ListNotificationRequestScope[keyof typeof ListNotificationRequestScope];


/**
 * 
 * @export
 * @interface ListNotificationsRequestDto
 */
export interface ListNotificationsRequestDto {
    /**
     * current page
     * @type {number}
     * @memberof ListNotificationsRequestDto
     */
    'page'?: number;
    /**
     * rows per page
     * @type {number}
     * @memberof ListNotificationsRequestDto
     */
    'limit'?: number;
    /**
     * 
     * @type {ListNotificationRequestScope}
     * @memberof ListNotificationsRequestDto
     */
    'scope': ListNotificationRequestScope;
    /**
     * 
     * @type {ListNotificationRequestFiltersDto}
     * @memberof ListNotificationsRequestDto
     */
    'filters'?: ListNotificationRequestFiltersDto;
}
/**
 * 
 * @export
 * @interface ListNotificationsResponseDto
 */
export interface ListNotificationsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListNotificationsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<NotificationDto>}
     * @memberof ListNotificationsResponseDto
     */
    'results': Array<NotificationDto>;
}
/**
 * 
 * @export
 * @interface LoginRequestDto
 */
export interface LoginRequestDto {
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {
    /**
     * auth JWT
     * @type {string}
     * @memberof LoginResponseDto
     */
    'authToken': string;
    /**
     * token expires at (unix timestamp in seconds)
     * @type {number}
     * @memberof LoginResponseDto
     */
    'expiresAt': number;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponseDto
     */
    'isAdmin': boolean;
}
/**
 * 
 * @export
 * @interface MarkAllNotificationsAsUnread
 */
export interface MarkAllNotificationsAsUnread {
    /**
     * 
     * @type {string}
     * @memberof MarkAllNotificationsAsUnread
     */
    'notificationId': string;
}
/**
 * 
 * @export
 * @interface MimicUserDto
 */
export interface MimicUserDto {
    /**
     * 
     * @type {string}
     * @memberof MimicUserDto
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface ModuleDiagnosticsLastSeenResponseDto
 */
export interface ModuleDiagnosticsLastSeenResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleDiagnosticsLastSeenResponseDto
     */
    'moduleId': string;
    /**
     * 
     * @type {object}
     * @memberof ModuleDiagnosticsLastSeenResponseDto
     */
    'diagnostics': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleDiagnosticsLastSeenResponseDto
     */
    'lastSeenAt': string;
}
/**
 * 
 * @export
 * @interface ModuleDto
 */
export interface ModuleDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'status': ModuleDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'cameraPosition'?: ModuleDtoCameraPositionEnum;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'serialNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'workspaceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'imageKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'lastOnlineAt': string | null;
    /**
     * 
     * @type {ModuleDtoOwnerUser}
     * @memberof ModuleDto
     */
    'ownerUser': ModuleDtoOwnerUser;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleDto
     */
    'shouldDisplayLiveData': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleDto
     */
    'featureFlags': Array<string>;
}

export const ModuleDtoStatusEnum = {
    On: 'on',
    Off: 'off'
} as const;

export type ModuleDtoStatusEnum = typeof ModuleDtoStatusEnum[keyof typeof ModuleDtoStatusEnum];
export const ModuleDtoCameraPositionEnum = {
    Bunker: 'BUNKER',
    BoxFiller: 'BOX_FILLER',
    SizeGrader: 'SIZE_GRADER',
    Farmsort: 'FARMSORT'
} as const;

export type ModuleDtoCameraPositionEnum = typeof ModuleDtoCameraPositionEnum[keyof typeof ModuleDtoCameraPositionEnum];

/**
 * 
 * @export
 * @interface ModuleDtoOwnerUser
 */
export interface ModuleDtoOwnerUser {
    /**
     * 
     * @type {string}
     * @memberof ModuleDtoOwnerUser
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleDtoOwnerUser
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface ModuleNotificationSettingsDefaultSettingsDto
 */
export interface ModuleNotificationSettingsDefaultSettingsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDefaultSettingsDto
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDefaultSettingsDto
     */
    'phoneNumbers': Array<string>;
}
/**
 * 
 * @export
 * @interface ModuleNotificationSettingsDto
 */
export interface ModuleNotificationSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsDto
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleNotificationSettingsDto
     */
    'emailNotificationEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleNotificationSettingsDto
     */
    'smsNotificationEnabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDto
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDto
     */
    'phoneNumbers': Array<string>;
    /**
     * 
     * @type {ModuleNotificationSettingsDtoDefaultNotificationSettings}
     * @memberof ModuleNotificationSettingsDto
     */
    'defaultNotificationSettings': ModuleNotificationSettingsDtoDefaultNotificationSettings | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsDto
     */
    'createdAt': string;
    /**
     * 
     * @type {ModuleNotificationSettingsModuleDto}
     * @memberof ModuleNotificationSettingsDto
     */
    'module': ModuleNotificationSettingsModuleDto;
}
/**
 * 
 * @export
 * @interface ModuleNotificationSettingsDtoDefaultNotificationSettings
 */
export interface ModuleNotificationSettingsDtoDefaultNotificationSettings {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDtoDefaultNotificationSettings
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDtoDefaultNotificationSettings
     */
    'phoneNumbers': Array<string>;
}
/**
 * 
 * @export
 * @interface ModuleNotificationSettingsModuleDto
 */
export interface ModuleNotificationSettingsModuleDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsModuleDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsModuleDto
     */
    'imageUrl': string | null;
}
/**
 * 
 * @export
 * @interface ModuleRunDto
 */
export interface ModuleRunDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'program': string | null;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunDto
     */
    'targets': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'lastUpdatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface ModuleRunMetricDto
 */
export interface ModuleRunMetricDto {
    /**
     * 
     * @type {number}
     * @memberof ModuleRunMetricDto
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunMetricDto
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof ModuleRunMetricDto
     */
    'mass': number;
}
/**
 * 
 * @export
 * @interface ModuleRunsDto
 */
export interface ModuleRunsDto {
    /**
     * 
     * @type {Array<ModuleRunMetricDto>}
     * @memberof ModuleRunsDto
     */
    'metrics': Array<ModuleRunMetricDto>;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'program': string | null;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunsDto
     */
    'targets': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'startTime': string;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunsDto
     */
    'module': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'lastUpdatedAt': string | null;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunsDto
     */
    'totalCount': object;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunsDto
     */
    'totalMass': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'duration': string;
}
/**
 * 
 * @export
 * @interface ModulesErrorSummaryDto
 */
export interface ModulesErrorSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryDto
     */
    'lastName': string;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalAdminErrorsLast7Days': number;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalAdminErrorsToday': number;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalNonAdminErrorsLast7Days': number;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalNonAdminErrorsToday': number;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalAdminOnlyUnread': number;
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryDto
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface ModulesErrorSummaryRequestDto
 */
export interface ModulesErrorSummaryRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModulesErrorSummaryRequestDto
     */
    'filteredCodes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryRequestDto
     */
    'since': string;
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryRequestDto
     */
    'today': string;
}
/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'type': NotificationDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'level': NotificationDtoLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'moduleId': string | null;
    /**
     * 
     * @type {NotificationDtoModule}
     * @memberof NotificationDto
     */
    'module': NotificationDtoModule | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDto
     */
    'isRead': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDto
     */
    'adminOnly': boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'createdAt': string;
}

export const NotificationDtoTypeEnum = {
    Error: 'module_error',
    TurnedOn: 'module_turned_on',
    TurnedOff: 'module_turned_off'
} as const;

export type NotificationDtoTypeEnum = typeof NotificationDtoTypeEnum[keyof typeof NotificationDtoTypeEnum];
export const NotificationDtoLevelEnum = {
    Info: 'info',
    Warning: 'warning',
    Error: 'error',
    Success: 'success'
} as const;

export type NotificationDtoLevelEnum = typeof NotificationDtoLevelEnum[keyof typeof NotificationDtoLevelEnum];

/**
 * 
 * @export
 * @interface NotificationDtoModule
 */
export interface NotificationDtoModule {
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoModule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoModule
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface NotificationModuleDto
 */
export interface NotificationModuleDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModuleDto
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface NotificationUpdateReadStatus
 */
export interface NotificationUpdateReadStatus {
    /**
     * 
     * @type {string}
     * @memberof NotificationUpdateReadStatus
     */
    'notificationId': string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationUpdateReadStatus
     */
    'isRead': boolean;
}
/**
 * 
 * @export
 * @interface PatchThresholdSettingsRequestDto
 */
export interface PatchThresholdSettingsRequestDto {
    /**
     * 
     * @type {number}
     * @memberof PatchThresholdSettingsRequestDto
     */
    'thresholdValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchThresholdSettingsRequestDto
     */
    'isEnabled': boolean;
}
/**
 * 
 * @export
 * @interface QualicamEntriesResponseDto
 */
export interface QualicamEntriesResponseDto {
    /**
     * 
     * @type {Array<QualicamEntryDto>}
     * @memberof QualicamEntriesResponseDto
     */
    'entries': Array<QualicamEntryDto>;
    /**
     * 
     * @type {boolean}
     * @memberof QualicamEntriesResponseDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntriesResponseDto
     */
    'totalPages': number;
}
/**
 * 
 * @export
 * @interface QualicamEntryDto
 */
export interface QualicamEntryDto {
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryDto
     */
    'imageUrl': string;
    /**
     * 
     * @type {object}
     * @memberof QualicamEntryDto
     */
    'metaData': object;
}
/**
 * 
 * @export
 * @interface QualicamEntryOverviewDto
 */
export interface QualicamEntryOverviewDto {
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'imageUrl': string;
    /**
     * 
     * @type {object}
     * @memberof QualicamEntryOverviewDto
     */
    'metaData': object;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'totalWeight': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'aStock': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'aStockWeight': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'bStock': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'bStockWeight': number;
    /**
     * 
     * @type {Array<ClassDistributionDto>}
     * @memberof QualicamEntryOverviewDto
     */
    'classDistribution': Array<ClassDistributionDto>;
    /**
     * 
     * @type {Array<SizeDistributionDto>}
     * @memberof QualicamEntryOverviewDto
     */
    'sizeDistribution': Array<SizeDistributionDto>;
}
/**
 * 
 * @export
 * @interface SizeDistributionDto
 */
export interface SizeDistributionDto {
    /**
     * 
     * @type {string}
     * @memberof SizeDistributionDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof SizeDistributionDto
     */
    'percent': number;
    /**
     * 
     * @type {number}
     * @memberof SizeDistributionDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof SizeDistributionDto
     */
    'totalWeight': number;
}
/**
 * 
 * @export
 * @interface ThresholdSettingDto
 */
export interface ThresholdSettingDto {
    /**
     * 
     * @type {string}
     * @memberof ThresholdSettingDto
     */
    'moduleId': string;
    /**
     * 
     * @type {ThresholdSettingDtoNotificationSettings}
     * @memberof ThresholdSettingDto
     */
    'notificationSettings': ThresholdSettingDtoNotificationSettings;
}
/**
 * 
 * @export
 * @interface ThresholdSettingDtoNotificationSettings
 */
export interface ThresholdSettingDtoNotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'artifactThresholdEnabled'?: boolean;
    /**
     * 
     * @type {Array<ArtifactThresholdDto>}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'artifactThresholds'?: Array<ArtifactThresholdDto>;
    /**
     * 
     * @type {Array<ErrorLogDto>}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'errorLogs'?: Array<ErrorLogDto>;
    /**
     * 
     * @type {string}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'notificationSettingsId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'renotifyIntervalMinutes'?: number;
}
/**
 * 
 * @export
 * @interface ToggleModuleNotificationSettingsRequestDto
 */
export interface ToggleModuleNotificationSettingsRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleModuleNotificationSettingsRequestDto
     */
    'isEnabled': boolean;
}
/**
 * 
 * @export
 * @interface UpdateDefaultNotificationSettingsRequestDto
 */
export interface UpdateDefaultNotificationSettingsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'emailNotificationEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'phoneNumbers'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'smsNotificationsEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'dndStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'dndEnd'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateModuleNotificationSettingsRequestDto
 */
export interface UpdateModuleNotificationSettingsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'emailNotificationsEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'phoneNumbers'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'smsNotificationsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'useDefaultNotificationSettings'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateOneDto
 */
export interface UpdateOneDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOneDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOneDto
     */
    'imageKey'?: string;
}

/**
 * AdminAssetsApi - axios parameter creator
 * @export
 */
export const AdminAssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp'} mimeType 
         * @param {string} imageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetsControllerGetUploadUrl: async (mimeType: 'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp', imageKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mimeType' is not null or undefined
            assertParamExists('adminAssetsControllerGetUploadUrl', 'mimeType', mimeType)
            // verify required parameter 'imageKey' is not null or undefined
            assertParamExists('adminAssetsControllerGetUploadUrl', 'imageKey', imageKey)
            const localVarPath = `/admin/assets/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mimeType !== undefined) {
                localVarQueryParameter['mimeType'] = mimeType;
            }

            if (imageKey !== undefined) {
                localVarQueryParameter['imageKey'] = imageKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAssetsApi - functional programming interface
 * @export
 */
export const AdminAssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp'} mimeType 
         * @param {string} imageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAssetsControllerGetUploadUrl(mimeType: 'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp', imageKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPresignedUploadUrlResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAssetsControllerGetUploadUrl(mimeType, imageKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminAssetsApi - factory interface
 * @export
 */
export const AdminAssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAssetsApiFp(configuration)
    return {
        /**
         * 
         * @param {'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp'} mimeType 
         * @param {string} imageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetsControllerGetUploadUrl(mimeType: 'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp', imageKey: string, options?: any): AxiosPromise<GetPresignedUploadUrlResponseDto> {
            return localVarFp.adminAssetsControllerGetUploadUrl(mimeType, imageKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAssetsApi - object-oriented interface
 * @export
 * @class AdminAssetsApi
 * @extends {BaseAPI}
 */
export class AdminAssetsApi extends BaseAPI {
    /**
     * 
     * @param {'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp'} mimeType 
     * @param {string} imageKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAssetsApi
     */
    public adminAssetsControllerGetUploadUrl(mimeType: 'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp', imageKey: string, options?: AxiosRequestConfig) {
        return AdminAssetsApiFp(this.configuration).adminAssetsControllerGetUploadUrl(mimeType, imageKey, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminModuleRunsApi - axios parameter creator
 * @export
 */
export const AdminModuleRunsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AggregateModuleRunsRequestDto} aggregateModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerAggregate: async (aggregateModuleRunsRequestDto: AggregateModuleRunsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateModuleRunsRequestDto' is not null or undefined
            assertParamExists('moduleRunsControllerAggregate', 'aggregateModuleRunsRequestDto', aggregateModuleRunsRequestDto)
            const localVarPath = `/admin/module-runs/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggregateModuleRunsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ListModuleRunsRequestDto} listModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindAll: async (listModuleRunsRequestDto: ListModuleRunsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listModuleRunsRequestDto' is not null or undefined
            assertParamExists('moduleRunsControllerFindAll', 'listModuleRunsRequestDto', listModuleRunsRequestDto)
            const localVarPath = `/admin/module-runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listModuleRunsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindChartDataForRunId: async (runId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('moduleRunsControllerFindChartDataForRunId', 'runId', runId)
            const localVarPath = `/admin/module-runs/chart-data/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moduleRunsControllerFindOne', 'id', id)
            const localVarPath = `/admin/module-runs/by-module-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerGetRunMetricsTotalsForPeriods: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/module-runs/run-metrics-totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminModuleRunsApi - functional programming interface
 * @export
 */
export const AdminModuleRunsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminModuleRunsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AggregateModuleRunsRequestDto} aggregateModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerAggregate(aggregateModuleRunsRequestDto: AggregateModuleRunsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateModuleRunsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerAggregate(aggregateModuleRunsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ListModuleRunsRequestDto} listModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerFindAll(listModuleRunsRequestDto: ListModuleRunsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListModuleRunsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerFindAll(listModuleRunsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerFindChartDataForRunId(runId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerFindChartDataForRunId(runId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AugmentedModuleRunDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerGetRunMetricsTotalsForPeriods(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateModuleRunMetricTotalsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerGetRunMetricsTotalsForPeriods(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminModuleRunsApi - factory interface
 * @export
 */
export const AdminModuleRunsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminModuleRunsApiFp(configuration)
    return {
        /**
         * 
         * @param {AggregateModuleRunsRequestDto} aggregateModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerAggregate(aggregateModuleRunsRequestDto: AggregateModuleRunsRequestDto, options?: any): AxiosPromise<AggregateModuleRunsResponseDto> {
            return localVarFp.moduleRunsControllerAggregate(aggregateModuleRunsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ListModuleRunsRequestDto} listModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindAll(listModuleRunsRequestDto: ListModuleRunsRequestDto, options?: any): AxiosPromise<ListModuleRunsResponseDto> {
            return localVarFp.moduleRunsControllerFindAll(listModuleRunsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindChartDataForRunId(runId: string, options?: any): AxiosPromise<void> {
            return localVarFp.moduleRunsControllerFindChartDataForRunId(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindOne(id: string, options?: any): AxiosPromise<AugmentedModuleRunDto> {
            return localVarFp.moduleRunsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerGetRunMetricsTotalsForPeriods(options?: any): AxiosPromise<AggregateModuleRunMetricTotalsResponseDto> {
            return localVarFp.moduleRunsControllerGetRunMetricsTotalsForPeriods(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminModuleRunsApi - object-oriented interface
 * @export
 * @class AdminModuleRunsApi
 * @extends {BaseAPI}
 */
export class AdminModuleRunsApi extends BaseAPI {
    /**
     * 
     * @param {AggregateModuleRunsRequestDto} aggregateModuleRunsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerAggregate(aggregateModuleRunsRequestDto: AggregateModuleRunsRequestDto, options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerAggregate(aggregateModuleRunsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ListModuleRunsRequestDto} listModuleRunsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerFindAll(listModuleRunsRequestDto: ListModuleRunsRequestDto, options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerFindAll(listModuleRunsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerFindChartDataForRunId(runId: string, options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerFindChartDataForRunId(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerGetRunMetricsTotalsForPeriods(options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerGetRunMetricsTotalsForPeriods(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminModulesApi - axios parameter creator
 * @export
 */
export const AdminModulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateModuleDto} createModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerCreate: async (createModuleDto: CreateModuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createModuleDto' is not null or undefined
            assertParamExists('adminModulesControllerCreate', 'createModuleDto', createModuleDto)
            const localVarPath = `/admin/modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createModuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminModulesControllerDelete', 'id', id)
            const localVarPath = `/admin/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'on' | 'off'} [status] 
         * @param {boolean} [onlyFarmsorts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerFindAll: async (page?: number, limit?: number, status?: 'on' | 'off', onlyFarmsorts?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (onlyFarmsorts !== undefined) {
                localVarQueryParameter['onlyFarmsorts'] = onlyFarmsorts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminModulesControllerFindOne', 'id', id)
            const localVarPath = `/admin/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOneDto} updateOneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerUpdateOne: async (id: string, updateOneDto: UpdateOneDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminModulesControllerUpdateOne', 'id', id)
            // verify required parameter 'updateOneDto' is not null or undefined
            assertParamExists('adminModulesControllerUpdateOne', 'updateOneDto', updateOneDto)
            const localVarPath = `/admin/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminModulesApi - functional programming interface
 * @export
 */
export const AdminModulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminModulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateModuleDto} createModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerCreate(createModuleDto: CreateModuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerCreate(createModuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'on' | 'off'} [status] 
         * @param {boolean} [onlyFarmsorts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerFindAll(page?: number, limit?: number, status?: 'on' | 'off', onlyFarmsorts?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListModulesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerFindAll(page, limit, status, onlyFarmsorts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOneDto} updateOneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerUpdateOne(id: string, updateOneDto: UpdateOneDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerUpdateOne(id, updateOneDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminModulesApi - factory interface
 * @export
 */
export const AdminModulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminModulesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateModuleDto} createModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerCreate(createModuleDto: CreateModuleDto, options?: any): AxiosPromise<ModuleDto> {
            return localVarFp.adminModulesControllerCreate(createModuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminModulesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'on' | 'off'} [status] 
         * @param {boolean} [onlyFarmsorts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerFindAll(page?: number, limit?: number, status?: 'on' | 'off', onlyFarmsorts?: boolean, options?: any): AxiosPromise<ListModulesResponseDto> {
            return localVarFp.adminModulesControllerFindAll(page, limit, status, onlyFarmsorts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerFindOne(id: string, options?: any): AxiosPromise<ModuleDto> {
            return localVarFp.adminModulesControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOneDto} updateOneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerUpdateOne(id: string, updateOneDto: UpdateOneDto, options?: any): AxiosPromise<ModuleDto> {
            return localVarFp.adminModulesControllerUpdateOne(id, updateOneDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminModulesApi - object-oriented interface
 * @export
 * @class AdminModulesApi
 * @extends {BaseAPI}
 */
export class AdminModulesApi extends BaseAPI {
    /**
     * 
     * @param {CreateModuleDto} createModuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerCreate(createModuleDto: CreateModuleDto, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerCreate(createModuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {'on' | 'off'} [status] 
     * @param {boolean} [onlyFarmsorts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerFindAll(page?: number, limit?: number, status?: 'on' | 'off', onlyFarmsorts?: boolean, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerFindAll(page, limit, status, onlyFarmsorts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateOneDto} updateOneDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerUpdateOne(id: string, updateOneDto: UpdateOneDto, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerUpdateOne(id, updateOneDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminNotificationSettingsApi - axios parameter creator
 * @export
 */
export const AdminNotificationSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerFindDefaultNotificationSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications-settings/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerGetThresholdSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications-settings/modules/thresholdsettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerListModulesNotificationSettings: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications-settings/modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thresholdSettingId 
         * @param {PatchThresholdSettingsRequestDto} patchThresholdSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerPatchThresholdSettings: async (thresholdSettingId: string, patchThresholdSettingsRequestDto: PatchThresholdSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thresholdSettingId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerPatchThresholdSettings', 'thresholdSettingId', thresholdSettingId)
            // verify required parameter 'patchThresholdSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerPatchThresholdSettings', 'patchThresholdSettingsRequestDto', patchThresholdSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/thresholdsettings/{thresholdSettingId}`
                .replace(`{${"thresholdSettingId"}}`, encodeURIComponent(String(thresholdSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchThresholdSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {IntervallNotificationSettingsRequestDto} intervallNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerSetNotificationInterval: async (moduleNotificationSettingsId: string, intervallNotificationSettingsRequestDto: IntervallNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleNotificationSettingsId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerSetNotificationInterval', 'moduleNotificationSettingsId', moduleNotificationSettingsId)
            // verify required parameter 'intervallNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerSetNotificationInterval', 'intervallNotificationSettingsRequestDto', intervallNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/notificationsettings/set-notification-interval/{moduleNotificationSettingsId}`
                .replace(`{${"moduleNotificationSettingsId"}}`, encodeURIComponent(String(moduleNotificationSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(intervallNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettings: async (moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleNotificationSettingsId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettings', 'moduleNotificationSettingsId', moduleNotificationSettingsId)
            // verify required parameter 'toggleModuleNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettings', 'toggleModuleNotificationSettingsRequestDto', toggleModuleNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/notificationsettings/toggle/{moduleNotificationSettingsId}`
                .replace(`{${"moduleNotificationSettingsId"}}`, encodeURIComponent(String(moduleNotificationSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleModuleNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors: async (moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleNotificationSettingsId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors', 'moduleNotificationSettingsId', moduleNotificationSettingsId)
            // verify required parameter 'toggleModuleNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors', 'toggleModuleNotificationSettingsRequestDto', toggleModuleNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/notificationsettings/errors/toggle/{moduleNotificationSettingsId}`
                .replace(`{${"moduleNotificationSettingsId"}}`, encodeURIComponent(String(moduleNotificationSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleModuleNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDefaultNotificationSettingsRequestDto} updateDefaultNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerUpdateDefaultNotificationSettings: async (updateDefaultNotificationSettingsRequestDto: UpdateDefaultNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDefaultNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerUpdateDefaultNotificationSettings', 'updateDefaultNotificationSettingsRequestDto', updateDefaultNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDefaultNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {UpdateModuleNotificationSettingsRequestDto} updateModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerUpdateModule: async (moduleNotificationSettingsId: string, updateModuleNotificationSettingsRequestDto: UpdateModuleNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleNotificationSettingsId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerUpdateModule', 'moduleNotificationSettingsId', moduleNotificationSettingsId)
            // verify required parameter 'updateModuleNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerUpdateModule', 'updateModuleNotificationSettingsRequestDto', updateModuleNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/{moduleNotificationSettingsId}`
                .replace(`{${"moduleNotificationSettingsId"}}`, encodeURIComponent(String(moduleNotificationSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModuleNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationSettingsApi - functional programming interface
 * @export
 */
export const AdminNotificationSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerFindDefaultNotificationSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultNotificationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerFindDefaultNotificationSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerGetThresholdSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThresholdSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerGetThresholdSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerListModulesNotificationSettings(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListModuleNotificationSettingsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerListModulesNotificationSettings(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} thresholdSettingId 
         * @param {PatchThresholdSettingsRequestDto} patchThresholdSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId: string, patchThresholdSettingsRequestDto: PatchThresholdSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId, patchThresholdSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {IntervallNotificationSettingsRequestDto} intervallNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId: string, intervallNotificationSettingsRequestDto: IntervallNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId, intervallNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateDefaultNotificationSettingsRequestDto} updateDefaultNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto: UpdateDefaultNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultNotificationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {UpdateModuleNotificationSettingsRequestDto} updateModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId: string, updateModuleNotificationSettingsRequestDto: UpdateModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleNotificationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId, updateModuleNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminNotificationSettingsApi - factory interface
 * @export
 */
export const AdminNotificationSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerFindDefaultNotificationSettings(options?: any): AxiosPromise<DefaultNotificationSettingsDto> {
            return localVarFp.adminNotificationSettingsControllerFindDefaultNotificationSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerGetThresholdSettings(options?: any): AxiosPromise<ThresholdSettingDto> {
            return localVarFp.adminNotificationSettingsControllerGetThresholdSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerListModulesNotificationSettings(page?: number, limit?: number, options?: any): AxiosPromise<ListModuleNotificationSettingsResponseDto> {
            return localVarFp.adminNotificationSettingsControllerListModulesNotificationSettings(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thresholdSettingId 
         * @param {PatchThresholdSettingsRequestDto} patchThresholdSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId: string, patchThresholdSettingsRequestDto: PatchThresholdSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId, patchThresholdSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {IntervallNotificationSettingsRequestDto} intervallNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId: string, intervallNotificationSettingsRequestDto: IntervallNotificationSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId, intervallNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDefaultNotificationSettingsRequestDto} updateDefaultNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto: UpdateDefaultNotificationSettingsRequestDto, options?: any): AxiosPromise<DefaultNotificationSettingsDto> {
            return localVarFp.adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {UpdateModuleNotificationSettingsRequestDto} updateModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId: string, updateModuleNotificationSettingsRequestDto: UpdateModuleNotificationSettingsRequestDto, options?: any): AxiosPromise<ModuleNotificationSettingsDto> {
            return localVarFp.adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId, updateModuleNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNotificationSettingsApi - object-oriented interface
 * @export
 * @class AdminNotificationSettingsApi
 * @extends {BaseAPI}
 */
export class AdminNotificationSettingsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerFindDefaultNotificationSettings(options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerFindDefaultNotificationSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerGetThresholdSettings(options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerGetThresholdSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerListModulesNotificationSettings(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerListModulesNotificationSettings(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thresholdSettingId 
     * @param {PatchThresholdSettingsRequestDto} patchThresholdSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId: string, patchThresholdSettingsRequestDto: PatchThresholdSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId, patchThresholdSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} moduleNotificationSettingsId 
     * @param {IntervallNotificationSettingsRequestDto} intervallNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId: string, intervallNotificationSettingsRequestDto: IntervallNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId, intervallNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} moduleNotificationSettingsId 
     * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} moduleNotificationSettingsId 
     * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDefaultNotificationSettingsRequestDto} updateDefaultNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto: UpdateDefaultNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} moduleNotificationSettingsId 
     * @param {UpdateModuleNotificationSettingsRequestDto} updateModuleNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId: string, updateModuleNotificationSettingsRequestDto: UpdateModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId, updateModuleNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminNotificationsApi - axios parameter creator
 * @export
 */
export const AdminNotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ListNotificationsRequestDto} listNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerFindMany: async (listNotificationsRequestDto: ListNotificationsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listNotificationsRequestDto' is not null or undefined
            assertParamExists('adminNotificationsControllerFindMany', 'listNotificationsRequestDto', listNotificationsRequestDto)
            const localVarPath = `/admin/notifications/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listNotificationsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerFindUnreadErrorNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications/unread-error-notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkAllNotificationsAsUnread} markAllNotificationsAsUnread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerMarkAllNotificationsAsRead: async (markAllNotificationsAsUnread: MarkAllNotificationsAsUnread, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markAllNotificationsAsUnread' is not null or undefined
            assertParamExists('adminNotificationsControllerMarkAllNotificationsAsRead', 'markAllNotificationsAsUnread', markAllNotificationsAsUnread)
            const localVarPath = `/admin/notifications/mark-all-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markAllNotificationsAsUnread, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationUpdateReadStatus} notificationUpdateReadStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerToggleReadStatus: async (notificationUpdateReadStatus: NotificationUpdateReadStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationUpdateReadStatus' is not null or undefined
            assertParamExists('adminNotificationsControllerToggleReadStatus', 'notificationUpdateReadStatus', notificationUpdateReadStatus)
            const localVarPath = `/admin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationUpdateReadStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationsApi - functional programming interface
 * @export
 */
export const AdminNotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ListNotificationsRequestDto} listNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerFindMany(listNotificationsRequestDto: ListNotificationsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotificationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerFindMany(listNotificationsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerFindUnreadErrorNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerFindUnreadErrorNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MarkAllNotificationsAsUnread} markAllNotificationsAsUnread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread: MarkAllNotificationsAsUnread, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {NotificationUpdateReadStatus} notificationUpdateReadStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerToggleReadStatus(notificationUpdateReadStatus: NotificationUpdateReadStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotificationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerToggleReadStatus(notificationUpdateReadStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminNotificationsApi - factory interface
 * @export
 */
export const AdminNotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {ListNotificationsRequestDto} listNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerFindMany(listNotificationsRequestDto: ListNotificationsRequestDto, options?: any): AxiosPromise<ListNotificationsResponseDto> {
            return localVarFp.adminNotificationsControllerFindMany(listNotificationsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerFindUnreadErrorNotifications(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.adminNotificationsControllerFindUnreadErrorNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkAllNotificationsAsUnread} markAllNotificationsAsUnread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread: MarkAllNotificationsAsUnread, options?: any): AxiosPromise<object> {
            return localVarFp.adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationUpdateReadStatus} notificationUpdateReadStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerToggleReadStatus(notificationUpdateReadStatus: NotificationUpdateReadStatus, options?: any): AxiosPromise<ListNotificationsResponseDto> {
            return localVarFp.adminNotificationsControllerToggleReadStatus(notificationUpdateReadStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNotificationsApi - object-oriented interface
 * @export
 * @class AdminNotificationsApi
 * @extends {BaseAPI}
 */
export class AdminNotificationsApi extends BaseAPI {
    /**
     * 
     * @param {ListNotificationsRequestDto} listNotificationsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerFindMany(listNotificationsRequestDto: ListNotificationsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerFindMany(listNotificationsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerFindUnreadErrorNotifications(options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerFindUnreadErrorNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkAllNotificationsAsUnread} markAllNotificationsAsUnread 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread: MarkAllNotificationsAsUnread, options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationUpdateReadStatus} notificationUpdateReadStatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerToggleReadStatus(notificationUpdateReadStatus: NotificationUpdateReadStatus, options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerToggleReadStatus(notificationUpdateReadStatus, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminRoleApi - axios parameter creator
 * @export
 */
export const AdminRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetAllModuleDiagnosticsLastSeen: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin-role/all-module-diagnostics-last-seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetAllUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin-role/all-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ModulesErrorSummaryRequestDto} modulesErrorSummaryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetModulesErrorSummary: async (modulesErrorSummaryRequestDto: ModulesErrorSummaryRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modulesErrorSummaryRequestDto' is not null or undefined
            assertParamExists('adminRoleControllerGetModulesErrorSummary', 'modulesErrorSummaryRequestDto', modulesErrorSummaryRequestDto)
            const localVarPath = `/admin-role/modules-errors-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modulesErrorSummaryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MimicUserDto} mimicUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerMimicUser: async (mimicUserDto: MimicUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mimicUserDto' is not null or undefined
            assertParamExists('adminRoleControllerMimicUser', 'mimicUserDto', mimicUserDto)
            const localVarPath = `/admin-role/mimic-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mimicUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminRoleApi - functional programming interface
 * @export
 */
export const AdminRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRoleControllerGetAllModuleDiagnosticsLastSeen(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleDiagnosticsLastSeenResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRoleControllerGetAllModuleDiagnosticsLastSeen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRoleControllerGetAllUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AllUsersResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRoleControllerGetAllUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ModulesErrorSummaryRequestDto} modulesErrorSummaryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto: ModulesErrorSummaryRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModulesErrorSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MimicUserDto} mimicUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRoleControllerMimicUser(mimicUserDto: MimicUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoginResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRoleControllerMimicUser(mimicUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminRoleApi - factory interface
 * @export
 */
export const AdminRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminRoleApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetAllModuleDiagnosticsLastSeen(options?: any): AxiosPromise<Array<ModuleDiagnosticsLastSeenResponseDto>> {
            return localVarFp.adminRoleControllerGetAllModuleDiagnosticsLastSeen(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetAllUsers(options?: any): AxiosPromise<Array<AllUsersResponseDto>> {
            return localVarFp.adminRoleControllerGetAllUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ModulesErrorSummaryRequestDto} modulesErrorSummaryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto: ModulesErrorSummaryRequestDto, options?: any): AxiosPromise<Array<ModulesErrorSummaryDto>> {
            return localVarFp.adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MimicUserDto} mimicUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerMimicUser(mimicUserDto: MimicUserDto, options?: any): AxiosPromise<Array<LoginResponseDto>> {
            return localVarFp.adminRoleControllerMimicUser(mimicUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminRoleApi - object-oriented interface
 * @export
 * @class AdminRoleApi
 * @extends {BaseAPI}
 */
export class AdminRoleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleApi
     */
    public adminRoleControllerGetAllModuleDiagnosticsLastSeen(options?: AxiosRequestConfig) {
        return AdminRoleApiFp(this.configuration).adminRoleControllerGetAllModuleDiagnosticsLastSeen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleApi
     */
    public adminRoleControllerGetAllUsers(options?: AxiosRequestConfig) {
        return AdminRoleApiFp(this.configuration).adminRoleControllerGetAllUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ModulesErrorSummaryRequestDto} modulesErrorSummaryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleApi
     */
    public adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto: ModulesErrorSummaryRequestDto, options?: AxiosRequestConfig) {
        return AdminRoleApiFp(this.configuration).adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MimicUserDto} mimicUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleApi
     */
    public adminRoleControllerMimicUser(mimicUserDto: MimicUserDto, options?: AxiosRequestConfig) {
        return AdminRoleApiFp(this.configuration).adminRoleControllerMimicUser(mimicUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerGetHealth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerGetHealth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthControllerGetHealth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerGetHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerGetHealth(options?: any): AxiosPromise<HealthControllerGetHealth200Response> {
            return localVarFp.healthControllerGetHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public healthControllerGetHealth(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthControllerGetHealth(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QualicamApi - axios parameter creator
 * @export
 */
export const QualicamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {QualicamEntryDto} qualicamEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerCreateQualicamEntry: async (qualicamEntryDto: QualicamEntryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'qualicamEntryDto' is not null or undefined
            assertParamExists('qualicamControllerCreateQualicamEntry', 'qualicamEntryDto', qualicamEntryDto)
            const localVarPath = `/qualicam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(qualicamEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {number} limit 
         * @param {number} page 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamEntry: async (qualicamName: string, limit: number, page: number, filter?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'qualicamName' is not null or undefined
            assertParamExists('qualicamControllerGetQualicamEntry', 'qualicamName', qualicamName)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('qualicamControllerGetQualicamEntry', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('qualicamControllerGetQualicamEntry', 'page', page)
            const localVarPath = `/qualicam/{qualicam_name}`
                .replace(`{${"qualicam_name"}}`, encodeURIComponent(String(qualicamName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamEntryOverview: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/qualicam/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamMetaData: async (qualicamName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'qualicamName' is not null or undefined
            assertParamExists('qualicamControllerGetQualicamMetaData', 'qualicamName', qualicamName)
            const localVarPath = `/qualicam/{qualicam_name}/metadata`
                .replace(`{${"qualicam_name"}}`, encodeURIComponent(String(qualicamName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QualicamApi - functional programming interface
 * @export
 */
export const QualicamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QualicamApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {QualicamEntryDto} qualicamEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qualicamControllerCreateQualicamEntry(qualicamEntryDto: QualicamEntryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualicamEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qualicamControllerCreateQualicamEntry(qualicamEntryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {number} limit 
         * @param {number} page 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qualicamControllerGetQualicamEntry(qualicamName: string, limit: number, page: number, filter?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualicamEntriesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qualicamControllerGetQualicamEntry(qualicamName, limit, page, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qualicamControllerGetQualicamEntryOverview(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QualicamEntryOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qualicamControllerGetQualicamEntryOverview(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qualicamControllerGetQualicamMetaData(qualicamName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualicamEntryOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qualicamControllerGetQualicamMetaData(qualicamName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QualicamApi - factory interface
 * @export
 */
export const QualicamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QualicamApiFp(configuration)
    return {
        /**
         * 
         * @param {QualicamEntryDto} qualicamEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerCreateQualicamEntry(qualicamEntryDto: QualicamEntryDto, options?: any): AxiosPromise<QualicamEntryDto> {
            return localVarFp.qualicamControllerCreateQualicamEntry(qualicamEntryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {number} limit 
         * @param {number} page 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamEntry(qualicamName: string, limit: number, page: number, filter?: Array<string>, options?: any): AxiosPromise<QualicamEntriesResponseDto> {
            return localVarFp.qualicamControllerGetQualicamEntry(qualicamName, limit, page, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamEntryOverview(options?: any): AxiosPromise<Array<QualicamEntryOverviewDto>> {
            return localVarFp.qualicamControllerGetQualicamEntryOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamMetaData(qualicamName: string, options?: any): AxiosPromise<QualicamEntryOverviewDto> {
            return localVarFp.qualicamControllerGetQualicamMetaData(qualicamName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QualicamApi - object-oriented interface
 * @export
 * @class QualicamApi
 * @extends {BaseAPI}
 */
export class QualicamApi extends BaseAPI {
    /**
     * 
     * @param {QualicamEntryDto} qualicamEntryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualicamApi
     */
    public qualicamControllerCreateQualicamEntry(qualicamEntryDto: QualicamEntryDto, options?: AxiosRequestConfig) {
        return QualicamApiFp(this.configuration).qualicamControllerCreateQualicamEntry(qualicamEntryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} qualicamName 
     * @param {number} limit 
     * @param {number} page 
     * @param {Array<string>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualicamApi
     */
    public qualicamControllerGetQualicamEntry(qualicamName: string, limit: number, page: number, filter?: Array<string>, options?: AxiosRequestConfig) {
        return QualicamApiFp(this.configuration).qualicamControllerGetQualicamEntry(qualicamName, limit, page, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualicamApi
     */
    public qualicamControllerGetQualicamEntryOverview(options?: AxiosRequestConfig) {
        return QualicamApiFp(this.configuration).qualicamControllerGetQualicamEntryOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} qualicamName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualicamApi
     */
    public qualicamControllerGetQualicamMetaData(qualicamName: string, options?: AxiosRequestConfig) {
        return QualicamApiFp(this.configuration).qualicamControllerGetQualicamMetaData(qualicamName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAuthApi - axios parameter creator
 * @export
 */
export const UserAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthControllerLogin: async (loginRequestDto: LoginRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequestDto' is not null or undefined
            assertParamExists('userAuthControllerLogin', 'loginRequestDto', loginRequestDto)
            const localVarPath = `/user/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthControllerValidateToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/auth/validate-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAuthApi - functional programming interface
 * @export
 */
export const UserAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthControllerLogin(loginRequestDto: LoginRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthControllerLogin(loginRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthControllerValidateToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthControllerValidateToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAuthApi - factory interface
 * @export
 */
export const UserAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthControllerLogin(loginRequestDto: LoginRequestDto, options?: any): AxiosPromise<LoginResponseDto> {
            return localVarFp.userAuthControllerLogin(loginRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthControllerValidateToken(options?: any): AxiosPromise<string> {
            return localVarFp.userAuthControllerValidateToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAuthApi - object-oriented interface
 * @export
 * @class UserAuthApi
 * @extends {BaseAPI}
 */
export class UserAuthApi extends BaseAPI {
    /**
     * 
     * @param {LoginRequestDto} loginRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public userAuthControllerLogin(loginRequestDto: LoginRequestDto, options?: AxiosRequestConfig) {
        return UserAuthApiFp(this.configuration).userAuthControllerLogin(loginRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public userAuthControllerValidateToken(options?: AxiosRequestConfig) {
        return UserAuthApiFp(this.configuration).userAuthControllerValidateToken(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindCurrentUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerFindCurrentUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerFindCurrentUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindCurrentUser(options?: any): AxiosPromise<CurrentUserResponseDto> {
            return localVarFp.usersControllerFindCurrentUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerFindCurrentUser(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerFindCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }
}


